import { camelizeKeys } from 'humps';
import { api, endpoints } from '@dom/utils';

import useApiEffect from '../hooks/useApiEffect';

import { reduxDB } from '../redux';

export const fetchGuideList = async () => {
  try {
    const { data } = await api.get(endpoints.profile.getGuideListings);
    return camelizeKeys(data);
  } catch (e) {
    // Handle error.
    console.log(e);
  };
};

export function useFetchGuideList() {
  useApiEffect(result => reduxDB.guides.populate(result), fetchGuideList);
};
